module.exports = __webpack_public_path__ + "static/media/tomatopizza.3b804b31.jpg";